







































































import { Component, Vue } from 'vue-property-decorator'
import { EP_URL } from '@/apps/open/constants'
import Button from '@/apps/open/components/Button'
import { IUserInfo } from '@/apps/open/store/modules/user/types'
import ServiceCard from './components/serviceCard.vue'
import PubCaseJSON from './case.json'
import PriCaseJSON from './pri-case.json'
import ScrollReveal from 'scrollreveal'
import { goApply } from '@/apps/open/utils'
import FooterInfo from '@/apps/open/layout/FooterInfo.vue'

@Component({
  components: {
    Button,
    ServiceCard,
    FooterInfo
  },
  data: () => ({
    EP_URL
  })
})
export default class Home extends Vue {
  serviceActiveTab = ''
  isSetScrollReveal = false
  get serviceTabs () {
    const pubServiceTabs = [{
      name: '特色功能服务',
      key: 'service'
    }, {
      name: 'WPS客户端二次开发',
      key: 'client'
    }]
    const serviceTabs = [{
      name: '金山文档',
      key: 'docs'
    }, {
      name: '企业能力',
      key: 'ability'
    }]
    return this.isPrivate ? serviceTabs : [
      ...serviceTabs,
      ...pubServiceTabs
    ]
  }

  get serviceInfoMap () {
    return this.isPrivate ? PriCaseJSON : PubCaseJSON
  }

  caseActive = 'baidu'

  get isPriDocMiddle () {
    return this.$store.getters['isPriDocMiddle']
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  mounted () {
    // 每次打开随机选中一个
    this.serviceActiveTab = this.serviceTabs[0].key
    this.initScrollReveal()
  }

  initScrollReveal () {
    ScrollReveal().reveal('.stats-list', { interval: 100, duration: 200, scale: 0.7, easing: 'cubic-bezier(.5, .5, .5, 1)' })
  }

  jumpApply (router_link: string) {
    goApply(router_link)
  }

  jumpAI () {
    window.open('https://openai.wps.cn/')
  }

  jumpDocMiddle () {
    window.open('https://www.kdocs.cn/l/cpDFbTYbUxYE')
  }

  jumpDoc () {
    window.open('/docs/office')
  }
}
